// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"562":"89ad933f","597":"d330f64e","826":"178e4209","926":"a917ec3e"}[chunkId] + ".chunk.js";
};